import React, { Component } from 'react';

import Icon from '../../Icon';
import { Wrapper } from './styled/WordLabelDeleteStyled';

interface Props {
    onClick: (name: string) => void;
    name: string;
}

class WordLabelDelete extends Component<Props> {
    onClick = () => {
        this.props.onClick(this.props.name);
    };

    render() {
        return (
            <Wrapper onClick={this.onClick}>
                <Icon name="Cross" />
            </Wrapper>
        );
    }
}

export default WordLabelDelete;
